import { Suspense, useEffect, useMemo } from 'react';
import { Outlet, useRequest, useLocation } from 'ice';
import { IntlProvider as ReactIntlProvider } from 'react-intl';
import { getCurrentMessages, getCurrentLang } from '@/locales';
import Header from '@/components/Header';
import Loading from '@/components/Loading';
import cls from 'classnames';
import style from './layout.module.scss';
import { useInit } from '@/hooks/useInit';
import useGetChannel from '@/hooks/useGetChannel';
import useDevice from '@/hooks/useDevice';
import useScrollToTop from '@/hooks/useScrollToTop';
import { ALERT_TYPE, LocalStorageKey, ROUTER_MAP } from '@/types';
import service from '@/request/service';
import IrenaGdpr from '@ali/icirena-gdpr';
import { SideBar } from '@/components/SideBar';
import useAddDrawer from '@/hooks/useAddDrawer';
import { localStorageHelper } from '@/utils/localCache';
import './transition.css';
import { isShortPage, getCurrentDev, DocTitle, parseQueryStringLocation, getQueryStringByName } from '@/utils';
import 'animate.css';
import useTheme from '@/hooks/useTheme';
import useSwitchConfig from '@/hooks/useSwitchConfig';
import initItrace from '@/utils/itrace';
import { Toast } from '@/components/Toast';
import { useRouter } from '@/hooks/useRouter';
import useRouterHistory from '@/hooks/useRouterHistory';
import useCinemaCurrencySign from '@/hooks/useCinemaCurrencySign';
import Footer from '@/components/Footer';
import useDomainAuth from '@/iHooks/useCheckDomain';
import Err from './err';

const currentDev = getCurrentDev();
export default function Layout() {
  try {
    const channelCode = getQueryStringByName('wapid');
    const { isAuth, isChecking } = useDomainAuth(channelCode);
    if (isChecking) return null;

    // 2. 处理未授权状态
    if (!isAuth) return <Err />;

    return <AuthorizedLayout />;
  } catch (error) {
    if (error instanceof Error) {
      console.error('Error in Layout component:', error);
    }
    return <Err />;
  }
}

function AuthorizedLayout() {
  useDevice();
  useScrollToTop();
  useGetChannel();
  useTheme();
  useSwitchConfig();
  useRouterHistory();
  const { drawerPortal } = useAddDrawer();
  const { data: channelInfo } = useRequest(service.channelAgreement, {
    manual: false,
    defaultParams: [
      {
        type: 'PERSONAL',
      },
    ],
  });
  useCinemaCurrencySign();

  const location = useLocation();
  const title = DocTitle();

  useEffect(() => {
    initItrace();
  }, []);

  useEffect(() => {
    document.title = title;
  }, [title]);

  useEffect(() => {
    const queryJson: any = parseQueryStringLocation(location.search);
    const Locale = localStorageHelper.get(LocalStorageKey.lang) || 'zh-TW';
    // console.log('Locale:', Locale);
    if (queryJson?.lang) {
      localStorageHelper.set(LocalStorageKey.lang, queryJson?.lang);
    }
    IrenaGdpr.init({
      acceptBtn: {
        callback: () => {},
      },
      rejectBtn: {
        callback: () => {},
      },
      language: queryJson?.lang || Locale,
      validityPeriod: 30,
      position: 'bottom',
    });
  }, [location]);

  const canShow = useInit();

  const { jump } = useRouter();
  const aaa = (type) => {
    window.localStorage.setItem('abc', type);
    jump(ROUTER_MAP.HOME);
    setTimeout(() => {
      window.location.reload();
    }, 300);
  };

  const devItem = useMemo(() => {
    return (
      <div>
        <div onClick={() => aaa('1')}>切换博纳</div>
        <div onClick={() => aaa('2')}>切换ACX</div>
        <div onClick={() => aaa('3')}>切换银河</div>
      </div>
    );
  }, [channelInfo]);
  const handleChangeChannel = () => {
    Toast({
      type: ALERT_TYPE.CONFIRM,
      render: devItem,
      content: devItem,
    });
  };

  if (isShortPage()) {
    return (
      <ReactIntlProvider locale={getCurrentLang()} messages={getCurrentMessages()}>
        <Suspense fallback={<Loading />}>
          <Outlet />
        </Suspense>
      </ReactIntlProvider>
    );
  }

  if (!canShow && !isShortPage()) {
    return <Loading />;
  }

  return (
    <ReactIntlProvider locale={getCurrentLang()} messages={getCurrentMessages()}>
      <div className={cls(style.root, {})} id="root">
        {currentDev === 'prod' ? null : (
          <div className={style.dev} onClick={handleChangeChannel}>
            DVE
          </div>
        )}
        <SideBar />
        <div className={style.vessel}>
          <Header />
          <div className={style.consumption} id={'scroll'}>
            <div className={cls(style.contextContainer)}>
              <div className={style.context}>
                <Suspense fallback={<Loading />}>
                  <Outlet />
                </Suspense>
              </div>
            </div>
            <Footer value={channelInfo?.result?.bizValue} />
          </div>
        </div>
        {drawerPortal}
      </div>
    </ReactIntlProvider>
  );
}
